import React from 'react';
import styled from 'styled-components/macro';
import useTranslations from '../../hooks/useTranslations';
import Select from '../engine/SelectEngine';
import InputBase from '../form/InputBase';

export const Container = styled.div`
  display: flex;
  align-items: center;

  & > * {
    margin-right: 0.8rem !important;
  }
`;

export const unitCountInputCSS = `
    max-width: 70px;
`;

const TimeBasedSchedulerGeneratorView = props => {
  const t = useTranslations();
  return (
    <Container>
      <span>{t('automations.wizard.trigger.time-based.is')}</span>
      <InputBase
        variant="outlined"
        type="number"
        customCSS={unitCountInputCSS}
        inputProps={{
          min: 0,
          max: 999
        }}
        onChange={props.setInterval}
        value={props.interval}
        data-testid="inteval-input"
      />
      <Select
        value={props.intervalUnit}
        onChange={v =>
          props.dispatch({
            type: 'update_condition',
            payload: { intervalUnit: v }
          })
        }
        options={[
          {
            value: 'day',
            text: t('scheduler.interval-unit.days', {
              count: props.interval
            }),
            'data-testid': 'scheduler-interval-unit-day'
          },
          {
            value: 'week',
            text: t('scheduler.interval-unit.weeks', {
              count: props.interval
            }),
            'data-testid': 'scheduler-interval-unit-week'
          },
          {
            value: 'month',
            text: t('scheduler.interval-unit.months', {
              count: props.interval
            }),
            'data-testid': 'scheduler-interval-unit-month'
          }
        ]}
        data-testid="interval-unit-select"
      />
    </Container>
  );
};

export default TimeBasedSchedulerGeneratorView;
